export default __webpack_public_path__ + "static/media/login-segment-disabled-smartphone-icon.c6f988b4.svg";